<template>
  <b-row v-if="value">
    <b-col>
      <h5 class="tsny_header">Category Scoring</h5>
      <b-table-simple
        class="tsny_text-mid text-center"
        thead-tr-class="tsny_table-head"
        tbody-tr-class="tsny_table-body"
      >
        <b-thead
          ><b-tr>
            <b-th>Raw Score</b-th>
            <b-th
              v-for="(count, category) in questionsPerCategory"
              :key="category"
            >
              {{ category }}
            </b-th>
          </b-tr> </b-thead
        ><b-tbody>
          <b-tr>
            <b-td>0</b-td>
            <b-td
              v-for="(count, category) in questionsPerCategory"
              :key="category"
            >
              <b-input
                class="tsny_input text-center"
                type="number"
                min="0"
                v-model="innerValue[category][0]"
              />
            </b-td>
          </b-tr>
          <b-tr v-for="i in highestRawScore" :key="i">
            <b-td>{{ i }}</b-td>
            <b-td
              v-for="(count, category) in questionsPerCategory"
              :key="category"
            >
              <b-input
                class="tsny_input text-center"
                v-if="i <= count"
                type="number"
                min="0"
                v-model="innerValue[category][i]"
              />
            </b-td> </b-tr
        ></b-tbody>
      </b-table-simple>
    </b-col>
  </b-row>
</template>

<script>
import { _ } from "vue-underscore";

export default {
  name: "SubscoreTable",
  props: {
    value: {
      type: Object,
      default: null
    },
    sections: {
      type: Array,
      default: null
    }
  },
  computed: {
    questionsPerCategory() {
      return _.chain(this.sections)
        .map(section =>
          _.countBy(section.questions, question => question.category)
        )
        .reduce(
          (categoryCounts, sectionCounts) => (
            _.chain(sectionCounts)
              .pairs()
              .each(
                ([category, count]) =>
                  (categoryCounts[category] =
                    (categoryCounts[category] || 0) + count)
              )
              .value(),
            categoryCounts
          ),
          {}
        )
        .value();
    },
    highestRawScore() {
      return _.chain(this.questionsPerCategory)
        .values()
        .max()
        .value();
    }
  },
  data: () => ({
    innerValue: null
  }),
  watch: {
    innerValue(val) {
      this.$emit("input", val);
    }
  },
  created() {
    let subscoreTable = this.generateSubscoreTable();

    if (this.value) {
      _.chain(this.value)
        .keys()
        .each(category => {
          if (subscoreTable.hasOwnProperty(category)) {
            _.chain(this.value[category])
              .keys()
              .each(questionCount => {
                if (questionCount <= this.questionsPerCategory[category]) {
                  subscoreTable[category][questionCount] = this.value[category][
                    questionCount
                  ];
                }
              });
          }
        });
    }

    this.innerValue = subscoreTable;
  },
  mounted() {},
  methods: {
    generateSubscoreTable() {
      let subscoreTable = {};
      _.chain(this.questionsPerCategory)
        .keys()
        .each(key => this.$set(subscoreTable, key, {}));
      return subscoreTable;
    }
  }
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
